export const FlowTransitionTypes = {
    Validate: 'V',
    Refuse: 'R',
};
export const FlowTransitionStateTypes = {
    Executed: 'Executed',
    InProcess: 'InProcess',
    Default: 'DefaultState'
};